import {useIndexedDB} from "react-indexed-db-hook";
import {useEffect, useState} from "react";

export default function useVehiclesState() {
	const dbValues = useIndexedDB("vehicles");
	const { getAll, add, deleteRecord, getByIndex: _getByIndex, clear: clearAll, getByID} = dbValues;

	const [vehicles, setVehicles] = useState([]);
	useEffect(() => {
		getAll()
			.then((valuesFromDB) => {
				setVehicles(valuesFromDB);
			})
			.catch(() => setVehicles([]));
	}, [dbValues]);

	const getByIndex = (indexName: string, key: any) => {
		if (indexName === 'id') {
			key = parseInt(key);
		}
		return vehicles.find(vehicle => vehicle[indexName] === key);
	}

	const deleteByIndex = (indexName: string, key: any) => {
		if (indexName === 'id') {
			return deleteRecord(parseInt(key))
		} else {
			return _getByIndex(indexName, key).then((entity) => deleteRecord(entity.id));
		}
	}

	return {vehicles, add, deleteRecord, getByIndex, getByIndexAsync: _getByIndex, deleteByIndex, clearAll};
}